import { Controller } from '@hotwired/stimulus'

import { Events, Forms, Strings } from '../constants'

import {
    target,
    retrieveSession,
    sendEvent,
    subscribeEvent,
    unsubscribeEvent,
    retrieveState,
    updateSession,
    notifier
} from '../utils'

import { updatePasswordPostRequest } from '../api'

export default class extends Controller {

    static targets = [
        'form',
        'password',
        'nuevo',
        'confirmar',
    ]

    static values = {
    }

    state = {
        session: null
    }

    instances = {
        validator: null
    }

    form = () => target(this, 'form')

    password = () => target(this, 'password')

    nuevo = () => target(this, 'nuevo')

    confirmar = () => target(this, 'confirmar')

    initialize = () => {

        this.instances.validator = new Validator(this.form(), this.update, Forms)
    }

    connect = () => {

        this.refreshOnLogin()

        subscribeEvent(Events.ON_LOGIN, this.refreshOnLogin)
    }

    disconnect = () => {

        unsubscribeEvent(Events.ON_LOGIN, this.refreshOnLogin)
    }

    refreshOnLogin = () => {

        retrieveSession()
            .then((session) => {

                if (! session) {

                    sendEvent(Events.SHOW_LOGIN, { message: '' })

                    return
                }

                this.state.session = session

                this.password().value = this.state.session.password
          })
          .catch(() => {

              sendEvent(Events.SHOW_LOGIN, { message: '' })
          })
    }

    update = (errors, isValid) => {

        if (! isValid) {

            return
        }

        if (this.nuevo().value !== this.confirmar().value) {

            notifier.alert(Strings.ERROR_PASSWORDS_NOT_MATCH)

            return
        }

        const form = new FormData(this.form())

        const params = Object.fromEntries(form.entries())

        params.rpe = this.state.session.rpe

        updatePasswordPostRequest(params)
            .then((response) => this.onUpdate(response, params))
            .catch((response) => this.onUpdate(response, params))
    }

    onUpdate = (response, params) => {

        if (response.estado) {

            const session = {
                rpe: params.rpe,
                password: params.nuevo
            }

            updateSession(session).then(() => {

                notifier.info(response.mensaje)

            }).catch(() => {})
        }
    }
}
